<template>
  <div class="app-container">
    <el-row :gutter="16" class="material-layout" type="flex" align="stretch">
      <el-col :span="5" class="folder-col">
        <el-card shadow="never" class="folder-card beauty-card">
          <div slot="header" class="folder-header">
            <div class="folder-title">
              <i class="el-icon-folder-opened"></i>
              <span>文件夹</span>
            </div>
            <div class="folder-actions">
              <div class="folder-actions-row">
                <div class="folder-actions-left">
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-folder-add"
                    v-hasPermi="['material:folder:create']"
                    @click="handleFolderCreate"
                  >新建</el-button>
                  <el-button
                    size="mini"
                    type="warning"
                    plain
                    icon="el-icon-edit"
                    v-hasPermi="['material:folder:update']"
                    @click="handleFolderRename"
                  >重命名</el-button>
                  <el-button
                    size="mini"
                    type="info"
                    plain
                    icon="el-icon-rank"
                    v-hasPermi="['material:folder:update']"
                    @click="handleFolderMove"
                  >移动</el-button>
                </div>
                <div class="folder-actions-right">
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    v-hasPermi="['material:folder:delete']"
                    @click="handleFolderDelete"
                  >删除</el-button>
                </div>
              </div>
              <div class="folder-actions-row folder-actions-row--single">
                <div class="folder-actions-left">
                  <el-button
                    size="mini"
                    type="success"
                    plain
                    icon="el-icon-price-tag"
                    v-hasPermi="['material:folder:update']"
                    @click="handleFolderBatchTag"
                  >批量打标签</el-button>
                </div>
              </div>
            </div>
          </div>
          <el-input
            v-model="folderFilter"
            size="small"
            clearable
            placeholder="搜索文件夹"
            prefix-icon="el-icon-search"
            class="folder-filter"
            @input="handleFolderFilter"
          />
          <el-tree
            :key="folderTreeKey"
            ref="folderTree"
            v-loading="folderLoading"
            :data="folderTree"
            :props="folderTreeProps"
            node-key="id"
            highlight-current
            :indent="18"
            :expand-on-click-node="false"
            :default-expanded-keys="expandedFolderIds"
            :filter-node-method="filterFolderNode"
            class="folder-tree"
            @node-click="handleFolderSelect"
            @node-expand="handleFolderNodeExpand"
            @node-collapse="handleFolderNodeCollapse"
          />
        </el-card>
      </el-col>
      <el-col :span="19" class="content-col">
        <div class="content-scroll-wrap">
        <el-card shadow="never" class="query-card beauty-card">
      <el-form :model="query" ref="queryForm" :inline="true" v-show="showSearch" class="glass-form compact-query-form">
        <el-form-item label="素材名称" prop="name">
          <el-input
            v-model="query.name"
            placeholder="请输入素材名称"
            clearable
            size="small"
            style="width: 170px"
            prefix-icon="el-icon-search"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="素材类型" prop="type">
          <el-select v-model="query.type" placeholder="全部类型" clearable size="small" style="width: 110px">
            <el-option label="图片" value="image" />
            <el-option label="视频" value="video" />
          </el-select>
        </el-form-item>
        <el-form-item label="标签" prop="tagIds">
          <el-select 
            v-model="query.tagIds" 
            placeholder="全部标签" 
            clearable 
            size="small" 
            multiple 
            collapse-tags
            style="width: 180px"
            @change="handleTagSelectChange"
          >
            <el-option key="__no_tags__" label="无标签" :value="-1">
              <span style="color: #999">○</span>
              <span style="margin-left: 8px">无标签</span>
            </el-option>
            <el-option
              v-for="tag in tagOptions"
              :key="tag.id"
              :label="tag.name"
              :value="tag.id"
            >
              <span :style="{ color: tag.color }">●</span>
              <span style="margin-left: 8px">{{ tag.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="createDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
            :picker-options="createDatePickerOptions"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="query" :inline="true" v-show="showSearch && !isDataLimited" class="glass-form metrics-filter-row" style="margin-top: -10px;">
        <el-form-item label="投放≥">
          <el-input-number
            v-model="query.adCountMin"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="投放≤">
          <el-input-number
            v-model="query.adCountMax"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="消耗≥">
          <el-input-number
            v-model="query.spendMin"
            :precision="2"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="消耗≤">
          <el-input-number
            v-model="query.spendMax"
            :precision="2"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="购物≥">
          <el-input-number
            v-model="query.purchasesMin"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="购物≤">
          <el-input-number
            v-model="query.purchasesMax"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="ROI≥">
          <el-input-number
            v-model="query.roiMin"
            :precision="4"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="ROI≤">
          <el-input-number
            v-model="query.roiMax"
            :precision="4"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="引用≥">
          <el-input-number
            v-model="query.referenceCountMin"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="引用≤">
          <el-input-number
            v-model="query.referenceCountMax"
            :min="0"
            size="small"
            class="metric-input"
            controls-position="right"
          />
        </el-form-item>
        <el-form-item label="仅消耗">
          <el-switch v-model="query.onlyWithConsumption" @change="handleQuery" />
        </el-form-item>
      </el-form>

      <div class="material-topbar">
        <div class="current-folder">
          <i class="el-icon-folder-opened"></i>
          <span>{{ currentFolderPath }}</span>
        </div>
        <div class="view-switch">
          <el-button-group>
            <el-button
              size="mini"
              icon="el-icon-menu"
              :type="viewMode === 'list' ? 'primary' : 'default'"
              @click="viewMode = 'list'"
            >列表</el-button>
            <el-button
              size="mini"
              icon="el-icon-s-grid"
              :type="viewMode === 'card' ? 'primary' : 'default'"
              @click="viewMode = 'card'"
            >卡片</el-button>
          </el-button-group>
        </div>
      </div>

      <table-operations
        :show-add="true"
        add-text="上传素材"
        add-icon="el-icon-upload2"
        @add="handleUpload"
        :show-delete="true"
        :delete-text="currentFolderId > 0 ? '从当前文件夹移除' : '批量删除'"
        :disable-delete="selection.length === 0"
        @delete="handleBatchDeleteOrRemove"
        class="material-ops"
      >
        <el-button
          v-if="viewMode === 'card'"
          :type="isAllSelected ? 'warning' : 'info'"
          plain
          :icon="isAllSelected ? 'el-icon-circle-close' : 'el-icon-finished'"
          size="mini"
          @click="handleToggleSelectAll"
        >{{ isAllSelected ? '取消全选' : '全选' }}</el-button>
        <el-button
          type="primary"
          plain
          icon="el-icon-folder"
          size="mini"
          :disabled="selection.length === 0"
          v-hasPermi="['material:material:update']"
          @click="handleBatchMove"
        >移动到文件夹</el-button>
        <el-button
          type="success"
          plain
          icon="el-icon-price-tag"
          size="mini"
          :disabled="selection.length === 0"
          v-hasPermi="['material:material:update']"
          @click="handleBatchTag"
        >批量打标签</el-button>
        <el-button
          type="primary"
          plain
          icon="el-icon-download"
          size="mini"
          v-hasPermi="['material:material:list']"
          @click="handleDownload"
        >下载</el-button>
        <el-button
          type="warning"
          plain
          icon="el-icon-picture-outline"
          size="mini"
          :disabled="selectedImageCount === 0"
          v-hasPermi="['material:ai:generate']"
          @click="handleBatchDerive"
        >批量衍生</el-button>
        <template slot="right-toolbar">
            <right-toolbar :showSearch.sync="showSearch" @queryTable="fetchList"></right-toolbar>
        </template>
      </table-operations>

      <!-- 卡片视图 -->
      <div
        v-if="viewMode === 'card'"
        v-loading="loading"
        ref="materialGrid"
        data-material-grid="true"
        class="material-grid"
      >
        <div
          v-for="item in materialList"
          :key="item.id"
          :data-id="item.id"
          class="material-card"
          :class="{ selected: selectedIdSet.has(item.id) }"
        >
          <div class="card-media">
            <img v-if="item.type === 'image'" :src="item.filePath" :alt="getDisplayName(item)" loading="lazy" />
            <img v-else-if="item.thumbnail" :src="item.thumbnail" :alt="getDisplayName(item)" class="video-cover-thumb" loading="lazy" />
            <video v-else :src="item.filePath" preload="none"></video>
            <div class="media-overlay">
              <el-button type="primary" icon="el-icon-zoom-in" circle size="mini" @click.stop="handlePreview(item)" />
              <el-button type="warning" icon="el-icon-edit" circle size="mini" @click.stop="handleUpdate(item)" />
              <el-button type="danger" icon="el-icon-delete" circle size="mini" @click.stop="handleDeleteOrRemove(item)" />
            </div>
            <div class="type-badge">
              <i :class="item.type === 'image' ? 'el-icon-picture-outline' : 'el-icon-video-camera'"></i>
            </div>
            <div v-if="selectedIdSet.has(item.id)" class="selected-badge">
              <i class="el-icon-check"></i>
            </div>
          </div>
          <div class="card-info">
            <div class="card-name" :title="'点击复制: ' + getDisplayName(item)" @click.stop="handleCopyName(getDisplayName(item))">
              <span class="card-name-text">{{ getDisplayName(item) }}</span>
              <i class="el-icon-copy-document card-name-copy-icon"></i>
            </div>
            <div class="card-tags">
              <el-tag
                v-for="tag in (item.tags || []).slice(0, 3)"
                :key="tag.id"
                :style="{ backgroundColor: tag.color, borderColor: tag.color, color: contrastColorCache[tag.color] || '#fff' }"
                size="mini"
                class="tag-item"
              >{{ tag.name }}</el-tag>
              <span v-if="item.tags && item.tags.length > 3" class="more-tags">+{{ item.tags.length - 3 }}</span>
            </div>
            <div v-if="!isDataLimited" class="card-metrics">
              <span class="metric-item">消耗 {{ formatMetricMoney(item.consumptionAgg && item.consumptionAgg.spend) }}</span>
              <span class="metric-item">投放 {{ formatMetricInt(item.adCount) }}</span>
              <span class="metric-item">购物 {{ formatMetricInt(item.consumptionAgg && item.consumptionAgg.purchases) }}</span>
              <span class="metric-item">ROI {{ formatMetricDecimal(item.consumptionAgg && item.consumptionAgg.roi, 4) }}</span>
              <el-tooltip content="点击查看引用明细" placement="top">
                <span
                  v-if="item.referenceCount != null && item.referenceCount > 0"
                  class="metric-item ref-count-link"
                  @click.stop="handleShowRefDetail(item)"
                >引用 {{ item.referenceCount }}</span>
                <span v-else class="metric-item">引用 0</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div v-if="materialList.length === 0 && !loading" class="empty-state">
          <i class="el-icon-folder-opened"></i>
          <p>暂无素材</p>
        </div>
      </div>

      <!-- 列表视图 -->
      <el-table
        v-else
        ref="materialTable"
        v-loading="loading"
        :data="materialList"
        class="beauty-table"
        :header-cell-style="{ background: '#f8fafd', color: '#606266', fontWeight: '600' }"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="预览" width="80" align="center">
          <template slot-scope="{ row }">
            <div
              class="table-preview-meta"
              :data-ads-file-url="row.filePath"
              :data-ads-thumbnail-url="row.thumbnail || ''"
              :data-ads-material-type="row.type"
            >
            <img v-if="row.type === 'image'" :src="row.thumbnail || row.filePath" class="table-thumb" loading="lazy" @click="handlePreview(row)" />
            <img v-else-if="row.thumbnail" :src="row.thumbnail" class="table-thumb" loading="lazy" @click="handlePreview(row)" />
            <video v-else :src="row.filePath" class="table-thumb" preload="none" @click="handlePreview(row)"></video>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="素材名称" min-width="260" :show-overflow-tooltip="false">
          <template slot-scope="{ row }">
            <span class="table-name-copy" :title="'点击复制: ' + getDisplayName(row)" @click="handleCopyName(getDisplayName(row))">
              <span class="table-name-text">{{ getDisplayName(row) }}</span>
              <i class="el-icon-copy-document table-name-copy-icon"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.type === 'image' ? 'success' : 'primary'" size="mini">
              {{ row.type === 'image' ? '图片' : '视频' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="标签" min-width="120">
          <template slot-scope="{ row }">
            <el-tag
              v-for="tag in row.tags || []"
              :key="tag.id"
              :style="{ backgroundColor: tag.color, borderColor: tag.color, color: contrastColorCache[tag.color] || '#fff' }"
              size="mini"
              class="tag-item"
            >{{ tag.name }}</el-tag>
            <span v-if="!row.tags || row.tags.length === 0">-</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isDataLimited" label="消耗" width="100" align="right" prop="spend" sortable="custom">
          <template slot-scope="{ row }">
            {{ formatMetricMoney(row.consumptionAgg && row.consumptionAgg.spend) }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isDataLimited" label="投放次数" width="90" align="right" prop="adCount" sortable="custom">
          <template slot-scope="{ row }">
            {{ formatMetricInt(row.adCount) }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isDataLimited" label="购物次数" width="90" align="right" prop="purchases" sortable="custom">
          <template slot-scope="{ row }">
            {{ formatMetricInt(row.consumptionAgg && row.consumptionAgg.purchases) }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isDataLimited" label="ROI" width="80" align="right" prop="roi" sortable="custom">
          <template slot-scope="{ row }">
            {{ formatMetricDecimal(row.consumptionAgg && row.consumptionAgg.roi, 4) }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isDataLimited" label="引用次数" width="85" align="center" sortable="custom" prop="referenceCount">
          <template slot-scope="{ row }">
            <el-tooltip content="点击查看引用明细" placement="top">
              <span
                v-if="row.referenceCount != null && row.referenceCount > 0"
                class="ref-count-link"
                @click="handleShowRefDetail(row)"
              >{{ row.referenceCount }}</span>
              <span v-else>{{ row.referenceCount || 0 }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="上传时间" width="140" align="center" />
        <el-table-column prop="createdBy" label="上传人" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createdBy || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-edit" class="op-edit" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" icon="el-icon-delete" class="op-delete" @click="handleDeleteOrRemove(scope.row)">{{ currentFolderId > 0 ? '从当前文件夹移除' : '删除' }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="query.pageNo"
        :limit.sync="query.pageSize"
        @pagination="fetchList"
      />
    </el-card>
        </div>
      </el-col>
    </el-row>

    <!-- 上传对话框 -->
    <el-dialog title="上传素材" :visible.sync="uploadDialogVisible" width="680px" append-to-body custom-class="beauty-dialog" @close="resetUploadDialog">
      <div class="upload-current-folder">
        <i class="el-icon-folder-opened"></i>
        <span>当前目录：{{ currentFolderPath }}</span>
        <span v-if="currentFolderId <= 0" class="upload-current-folder-tip">（当前为全部素材，重复文件仅复用不新增目录关联）</span>
      </div>
      <!-- 第一步：选择文件 -->
      <div v-if="uploadStep === 'select'">
        <el-upload
          class="upload-area"
          drag
          action="#"
          :auto-upload="false"
          :file-list="uploadFileList"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          multiple
          accept="image/*,video/*"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">支持图片和视频格式，单个文件大小上限以系统参数 material.upload.max-size-mb 为准</div>
        </el-upload>
        <el-form v-if="uploadFileList.length > 0" label-width="80px" class="upload-form">
          <el-form-item label="关联标签">
            <el-select v-model="uploadTags" multiple placeholder="选择标签" style="width: 100%">
              <el-option
                v-for="tag in tagOptions"
                :key="tag.id"
                :label="tag.name"
                :value="tag.id"
              >
                <span :style="{ color: tag.color }">●</span>
                <span style="margin-left: 8px">{{ tag.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!-- 第二步：校验结果确认 -->
      <div v-if="uploadStep === 'confirm'" class="upload-confirm">
        <div v-if="uploadCheckLoading" class="upload-checking">
          <i class="el-icon-loading"></i>
          <span>正在校验文件名，请稍候…</span>
        </div>
        <template v-else>
          <!-- 汇总统计 -->
          <div class="upload-summary">
            <el-tag type="success" size="medium">可上传 {{ uploadNewFiles.length }} 个</el-tag>
            <el-tag v-if="uploadDupFiles.length > 0" type="warning" size="medium" style="margin-left:8px">
              重复复用 {{ uploadDupFiles.length }} 个
            </el-tag>
          </div>

          <!-- 可上传列表 -->
          <div v-if="uploadNewFiles.length > 0" class="upload-file-group">
            <div class="upload-file-group-title">
              <i class="el-icon-circle-check" style="color:#67C23A"></i>
              可上传文件
            </div>
            <div class="upload-file-list">
              <div
                v-for="f in uploadNewFilesPreview"
                :key="f.name"
                class="upload-file-item upload-file-item--new"
              >
                <i :class="f.raw && f.raw.type && f.raw.type.startsWith('video') ? 'el-icon-video-camera' : 'el-icon-picture-outline'"></i>
                <span class="upload-file-name" :title="f.name">{{ f.name }}</span>
                <span class="upload-file-size">{{ formatFileSize(f.size || (f.raw && f.raw.size)) }}</span>
              </div>
              <div v-if="uploadNewHiddenCount > 0" class="upload-list-more-tip">
                仅展示前 {{ uploadPreviewLimit }} 条，剩余 {{ uploadNewHiddenCount }} 条将继续处理
              </div>
            </div>
          </div>

          <!-- 重复文件列表 -->
          <div v-if="uploadDupFiles.length > 0" class="upload-file-group">
            <div class="upload-file-group-title">
              <i class="el-icon-warning-outline" style="color:#E6A23C"></i>
              {{ currentFolderId > 0 ? '以下文件库中已存在，将自动关联到当前目录' : '以下文件库中已存在，将自动复用' }}
            </div>
            <div class="upload-file-list upload-file-list--dup">
              <div
                v-for="f in uploadDupFilesPreview"
                :key="f.name"
                class="upload-file-item upload-file-item--dup"
              >
                <i class="el-icon-document-delete"></i>
                <span class="upload-file-name" :title="f.name">{{ f.name }}</span>
                <el-tag type="warning" size="mini">{{ f.linkedToCurrentFolder ? '已在当前目录' : '将复用' }}</el-tag>
              </div>
              <div v-if="uploadDupHiddenCount > 0" class="upload-list-more-tip">
                仅展示前 {{ uploadPreviewLimit }} 条，剩余 {{ uploadDupHiddenCount }} 条将继续处理
              </div>
            </div>
          </div>

          <div v-if="uploadNewFiles.length === 0 && uploadDupFiles.length > 0" class="upload-all-dup">
            <i class="el-icon-warning" style="color:#E6A23C;font-size:20px"></i>
            <span>{{ currentFolderId > 0 ? '所选文件均已存在，点击“开始处理”将批量关联到当前目录' : '所选文件均已存在，点击“开始处理”将批量复用已有素材' }}</span>
          </div>
        </template>
      </div>

      <!-- 第三步：上传进度 -->
      <div v-if="uploadStep === 'uploading'" class="upload-progress-panel">
        <div class="upload-progress-header">
          <span>正在处理 {{ uploadDoneCount }}/{{ uploadProcessTotal }} 个文件</span>
          <span style="color:#909399;font-size:12px">请勿关闭此窗口</span>
        </div>
        <el-progress
          :percentage="uploadPercent"
          :status="uploadProgressStatus"
          :stroke-width="12"
          style="margin: 12px 0"
        />
        <div class="upload-progress-list">
          <div
            v-for="item in uploadProgressPreview"
            :key="item.name"
            class="upload-progress-item"
          >
            <i
              :class="{
                'el-icon-loading': item.status === 'uploading',
                'el-icon-circle-check': item.status === 'done',
                'el-icon-circle-close': item.status === 'error'
              }"
              :style="{
                color: item.status === 'done' ? '#67C23A' : item.status === 'error' ? '#F56C6C' : '#409EFF'
              }"
            ></i>
            <span class="upload-file-name" :title="item.name">{{ item.name }}</span>
            <span
              class="upload-progress-status"
              :style="{ color: item.status === 'done' ? '#67C23A' : item.status === 'error' ? '#F56C6C' : '#909399' }"
            >{{ item.statusText }}</span>
          </div>
          <div v-if="uploadProgressHiddenCount > 0" class="upload-list-more-tip">
            仅展示前 {{ uploadProgressPreviewLimit }} 条进度，剩余 {{ uploadProgressHiddenCount }} 条仍在处理
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <template v-if="uploadStep === 'select'">
          <el-button @click="uploadDialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            :loading="uploadCheckLoading"
            :disabled="uploadFileList.length === 0"
            @click="goCheckNames"
          >下一步</el-button>
        </template>
        <template v-if="uploadStep === 'confirm'">
          <el-button @click="uploadStep = 'select'" :disabled="uploadCheckLoading">上一步</el-button>
          <el-button
            type="primary"
            :disabled="uploadProcessTotal === 0 || uploadCheckLoading"
            @click="startUpload"
          >开始处理 {{ uploadProcessTotal > 0 ? uploadProcessTotal + ' 个' : '' }}</el-button>
        </template>
        <template v-if="uploadStep === 'uploading'">
          <el-button type="primary" :disabled="uploadPercent < 100" @click="finishUpload">完成</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 编辑对话框 -->
    <el-dialog :title="editTitle" :visible.sync="editDialogVisible" width="500px" append-to-body custom-class="beauty-dialog">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="素材名称" prop="name">
          <el-input v-model="editForm.name" placeholder="请输入素材名称" />
        </el-form-item>
        <el-form-item label="所属文件夹">
          <el-select
            v-model="editForm.folderIds"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="选择文件夹"
            style="width: 100%"
          >
            <el-option
              v-for="folder in folderOptions"
              :key="folder.id"
              :label="folder.label"
              :value="folder.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联标签">
          <el-select v-model="editForm.tagIds" multiple placeholder="选择标签" style="width: 100%">
            <el-option
              v-for="tag in tagOptions"
              :key="tag.id"
              :label="tag.name"
              :value="tag.id"
            >
              <span :style="{ color: tag.color }">●</span>
              <span style="margin-left: 8px">{{ tag.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 文件详情弹窗 -->
    <el-dialog
      :visible.sync="previewDialogVisible"
      width="940px"
      append-to-body
      custom-class="detail-dialog"
      :before-close="closeDetailDialog"
    >
      <div slot="title" class="detail-dialog-title">
        <i :class="previewItem && previewItem.type === 'image' ? 'el-icon-picture-outline' : 'el-icon-video-camera'"></i>
        <span>文件详情</span>
      </div>

      <div v-if="previewItem" class="detail-dialog-body">
        <!-- 左侧预览区 -->
        <div class="detail-preview-area">
          <img
            v-if="previewItem.type === 'image'"
            :src="previewItem.filePath"
            class="detail-preview-image"
            :style="{ transform: `scale(${detailZoomLevel})` }"
          />
          <video
            v-else
            :src="previewItem.filePath"
            controls
            class="detail-preview-video"
            :poster="previewItem.thumbnail"
          ></video>
        </div>

        <!-- 右侧信息区 -->
        <div class="detail-info-area">
          <div class="detail-section-title">基本信息</div>
          <div class="detail-info-grid">
            <div class="detail-info-item">
              <span class="detail-info-label">文件名称</span>
              <span class="detail-info-value" :title="getDisplayName(previewItem)">{{ getDisplayName(previewItem) }}</span>
            </div>
            <div class="detail-info-item">
              <span class="detail-info-label">所属文件夹</span>
              <span class="detail-info-value">{{ getDetailFolderName(previewItem.folderId) }}</span>
            </div>
            <div class="detail-info-item">
              <span class="detail-info-label">上传人</span>
              <span class="detail-info-value">{{ previewItem.createdBy || '-' }}</span>
            </div>
            <div class="detail-info-item">
              <span class="detail-info-label">文件大小</span>
              <span class="detail-info-value">{{ formatDetailFileSize(previewItem.fileSize) }}</span>
            </div>
            <div class="detail-info-item">
              <span class="detail-info-label">文件类型</span>
              <span class="detail-info-value">{{ previewItem.type === 'image' ? '图片' : '视频' }}</span>
            </div>
            <div class="detail-info-item">
              <span class="detail-info-label">上传时间</span>
              <span class="detail-info-value">{{ formatDetailTime(previewItem.createdAt) }}</span>
            </div>
            <div class="detail-info-item">
              <span class="detail-info-label">文件链接</span>
              <span class="detail-info-value">
                <el-button type="text" size="mini" icon="el-icon-link" @click="copyDetailLink(previewItem.filePath)">复制链接</el-button>
              </span>
            </div>
            <template v-if="previewItem.type === 'video'">
              <div class="detail-info-item" v-if="previewItem.duration">
                <span class="detail-info-label">视频时长</span>
                <span class="detail-info-value">{{ formatDetailDuration(previewItem.duration) }}</span>
              </div>
              <div class="detail-info-item" v-if="previewItem.width && previewItem.height">
                <span class="detail-info-label">视频分辨率</span>
                <span class="detail-info-value">{{ previewItem.width }}x{{ previewItem.height }}</span>
              </div>
            </template>
            <template v-if="previewItem.type === 'image'">
              <div class="detail-info-item" v-if="previewItem.width && previewItem.height">
                <span class="detail-info-label">图片尺寸</span>
                <span class="detail-info-value">{{ previewItem.width }}x{{ previewItem.height }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div slot="footer" class="detail-dialog-footer">
        <div class="detail-actions-left">
          <template v-if="previewItem && previewItem.type === 'image'">
            <el-tooltip content="放大" placement="top">
              <el-button size="mini" type="text" class="detail-action-btn" @click="detailZoomIn">
                <i class="el-icon-zoom-in"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="缩小" placement="top">
              <el-button size="mini" type="text" class="detail-action-btn" @click="detailZoomOut">
                <i class="el-icon-zoom-out"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip content="重置" placement="top">
              <el-button size="mini" type="text" class="detail-action-btn" @click="detailZoomReset">
                <i class="el-icon-full-screen"></i>
              </el-button>
            </el-tooltip>
          </template>
        </div>
        <div class="detail-actions-right">
          <el-tooltip content="下载" placement="top">
            <el-button size="mini" type="text" class="detail-action-btn" @click="handleDetailDownload">
              <i class="el-icon-download"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top">
            <el-button size="mini" type="text" class="detail-action-btn detail-action-btn--danger" @click="handleDetailDelete">
              <i class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </el-dialog>

    <!-- 文件夹对话框 -->
    <el-dialog :visible.sync="folderDialogVisible" width="420px" append-to-body custom-class="beauty-dialog folder-dialog">
      <template slot="title">
        <div class="dialog-title">
          <i class="el-icon-folder"></i>
          <span>{{ folderDialogTitle }}</span>
        </div>
      </template>
      <el-form ref="folderFormRef" :model="folderForm" :rules="folderRules" label-position="top">
        <el-form-item label="文件夹名称" prop="name">
          <el-input v-model="folderForm.name" placeholder="请输入文件夹名称" maxlength="128" show-word-limit />
        </el-form-item>
        <el-form-item label="父级文件夹">
          <div class="move-folder-tree-wrap" style="max-height:240px;">
            <div
              class="move-folder-item"
              :class="{ 'is-active': !folderForm.parentId || folderForm.parentId === 0 }"
              @click="folderForm.parentId = 0"
            >
              <i class="el-icon-folder-opened move-folder-icon"></i>
              <span>顶级</span>
              <i v-if="!folderForm.parentId || folderForm.parentId === 0" class="el-icon-check move-folder-check"></i>
            </div>
            <el-tree
              :data="folderParentTreeData"
              :props="{ children: 'children', label: 'name' }"
              node-key="id"
              :highlight-current="false"
              :expand-on-click-node="false"
              :default-expand-all="false"
              class="move-folder-tree"
              @node-click="(data) => { folderForm.parentId = data.id }"
            >
              <span slot-scope="{ data }" class="move-folder-tree-node" :class="{ 'is-active': folderForm.parentId === data.id }">
                <i :class="data.children && data.children.length ? 'el-icon-folder-opened' : 'el-icon-folder'" class="move-folder-icon"></i>
                <span>{{ data.name }}</span>
                <i v-if="folderForm.parentId === data.id" class="el-icon-check move-folder-check"></i>
              </span>
            </el-tree>
          </div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="folderForm.sort" :min="0" :step="1" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="folderDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="folderSaving" @click="submitFolder">保存</el-button>
      </div>
    </el-dialog>

    <!-- 文件夹移动对话框 -->
    <el-dialog title="移动文件夹" :visible.sync="folderMoveDialogVisible" width="440px" append-to-body custom-class="beauty-dialog move-folder-dialog">
      <div class="move-folder-body">
        <div class="move-folder-selected-tip">
          <i class="el-icon-info"></i>
          将 <strong>{{ currentFolder && currentFolder.name }}</strong> 移动到：
        </div>
        <div class="move-folder-tree-wrap">
          <div
            class="move-folder-item"
            :class="{ 'is-active': !folderMoveForm.targetParentId || folderMoveForm.targetParentId === 0 }"
            @click="folderMoveForm.targetParentId = 0"
          >
            <i class="el-icon-folder-opened move-folder-icon"></i>
            <span>顶级</span>
            <i v-if="!folderMoveForm.targetParentId || folderMoveForm.targetParentId === 0" class="el-icon-check move-folder-check"></i>
          </div>
          <el-tree
            :data="folderMoveTreeData"
            :props="{ children: 'children', label: 'name' }"
            node-key="id"
            :highlight-current="false"
            :expand-on-click-node="false"
            :default-expand-all="false"
            class="move-folder-tree"
            @node-click="(data) => { folderMoveForm.targetParentId = data.id }"
          >
            <span slot-scope="{ data }" class="move-folder-tree-node" :class="{ 'is-active': folderMoveForm.targetParentId === data.id }">
              <i :class="data.children && data.children.length ? 'el-icon-folder-opened' : 'el-icon-folder'" class="move-folder-icon"></i>
              <span>{{ data.name }}</span>
              <i v-if="folderMoveForm.targetParentId === data.id" class="el-icon-check move-folder-check"></i>
            </span>
          </el-tree>
        </div>
        <div style="margin-top:12px;">
          <el-checkbox v-model="folderMoveForm.includeChildren">下级文件夹一起移动</el-checkbox>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span class="move-folder-target-label">
          目标：<strong>{{ folderMoveForm.targetParentId && folderMoveForm.targetParentId !== 0 ? getFolderName(folderMoveForm.targetParentId) : '顶级' }}</strong>
        </span>
        <div>
          <el-button @click="folderMoveDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="folderMoveSaving" @click="submitFolderMove">确定移动</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 文件夹批量打标签 -->
    <el-dialog title="批量打标签" :visible.sync="folderTagDialogVisible" width="420px" append-to-body custom-class="beauty-dialog folder-dialog">
      <el-form label-position="top">
        <el-form-item label="选择标签">
          <el-select v-model="folderTagForm.tagIds" multiple filterable clearable placeholder="请选择标签" style="width: 100%">
            <el-option
              v-for="tag in tagOptions"
              :key="tag.id"
              :label="tag.name"
              :value="tag.id"
            >
              <span :style="{ color: tag.color }">●</span>
              <span style="margin-left: 8px">{{ tag.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作方式">
          <el-radio-group v-model="folderTagForm.mode">
            <el-radio label="append">追加</el-radio>
            <el-radio label="replace">覆盖</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-alert
          :title="folderTagForm.mode === 'replace'
            ? '将把该文件夹及其下级文件夹内素材的标签替换为所选标签'
            : '将对该文件夹及其下级文件夹内的全部素材追加标签'"
          type="info"
          :closable="false"
          show-icon
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="folderTagDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="folderTagSaving" @click="submitFolderBatchTag">确定</el-button>
      </div>
    </el-dialog>

    <!-- 素材批量打标签 -->
    <el-dialog title="批量打标签" :visible.sync="batchTagDialogVisible" width="420px" append-to-body custom-class="beauty-dialog folder-dialog">
      <el-form label-position="top">
        <el-form-item label="选择标签">
          <el-select v-model="batchTagForm.tagIds" multiple filterable clearable placeholder="请选择标签" style="width: 100%">
            <el-option
              v-for="tag in tagOptions"
              :key="tag.id"
              :label="tag.name"
              :value="tag.id"
            >
              <span :style="{ color: tag.color }">●</span>
              <span style="margin-left: 8px">{{ tag.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作方式">
          <el-radio-group v-model="batchTagForm.mode">
            <el-radio label="append">追加</el-radio>
            <el-radio label="replace">覆盖</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-alert
          :title="batchTagForm.mode === 'replace'
            ? '将把当前选中素材的标签替换为所选标签'
            : '将对当前选中素材追加标签（已存在的不会重复添加）'"
          type="info"
          :closable="false"
          show-icon
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchTagDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchTagSaving" @click="submitBatchTag">确定</el-button>
      </div>
    </el-dialog>

    <!-- 批量移动对话框 -->
    <el-dialog title="移动到文件夹" :visible.sync="moveDialogVisible" width="440px" append-to-body custom-class="beauty-dialog move-folder-dialog" @close="moveFolderDropdownVisible = false">
      <div class="move-folder-body">
        <div class="move-folder-selected-tip">
          <i class="el-icon-info"></i>
          已选 <strong>{{ selection.length }}</strong> 个素材，请选择目标文件夹：
        </div>
        <!-- 内嵌树形，直接展示 -->
        <div class="move-folder-tree-wrap">
          <!-- 未归档 -->
          <div
            class="move-folder-item"
            :class="{ 'is-active': moveForm.folderId === 0 }"
            @click="selectMoveFolder(0)"
          >
            <i class="el-icon-folder-opened move-folder-icon"></i>
            <span>未归档</span>
            <i v-if="moveForm.folderId === 0" class="el-icon-check move-folder-check"></i>
          </div>
          <!-- 文件夹树 -->
          <el-tree
            ref="moveFolderTreeRef"
            :data="moveFolderTreeData"
            :props="{ children: 'children', label: 'name' }"
            node-key="id"
            :highlight-current="false"
            :expand-on-click-node="false"
            :default-expand-all="false"
            class="move-folder-tree"
            @node-click="onMoveFolderTreeClick"
          >
            <span slot-scope="{ node, data }" class="move-folder-tree-node" :class="{ 'is-active': moveForm.folderId === data.id }">
              <i :class="data.children && data.children.length ? 'el-icon-folder-opened' : 'el-icon-folder'" class="move-folder-icon"></i>
              <span>{{ data.name }}</span>
              <i v-if="moveForm.folderId === data.id" class="el-icon-check move-folder-check"></i>
            </span>
          </el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span class="move-folder-target-label">
          目标：<strong>{{ getMoveTargetLabel() }}</strong>
        </span>
        <div>
          <el-button @click="moveDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="moveSaving" @click="submitMove">确定移动</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 素材下载对话框 -->
    <el-dialog title="下载素材" :visible.sync="downloadDialogVisible" width="520px" append-to-body custom-class="beauty-dialog folder-dialog">
      <div class="download-dialog-body">
        <el-alert
          title="选择目录将按目录结构打包；选择素材将扁平打包（无目录层级）"
          type="info"
          :closable="false"
          show-icon
          class="download-hint"
        />
        <el-form label-position="top">
          <el-form-item label="选择目录（可多选，含子文件夹）">
            <el-tree
              ref="downloadFolderTree"
              :data="downloadFolderTreeData"
              :props="{ children: 'children', label: 'name' }"
              node-key="id"
              show-checkbox
              :default-expand-all="false"
              class="download-folder-tree"
              @check="onDownloadFolderCheck"
            />
          </el-form-item>
          <el-form-item label="下载范围">
            <div v-if="downloadPreview && downloadPreview.totalCount > 0" class="download-preview-tip">
              <template v-if="downloadPreview.folderCount > 0">
                {{ downloadPreview.folderNames && downloadPreview.folderNames.length ? downloadPreview.folderNames.join('、') + '，' : '' }}{{ downloadPreview.folderCount }} 个文件夹
              </template>
              <template v-if="downloadPreview.materialCount > 0">
                <template v-if="downloadPreview.folderCount > 0">，</template>{{ downloadPreview.materialCount }} 个素材
              </template>
              ，共 <strong>{{ downloadPreview.totalCount }}</strong> 个文件
            </div>
            <span v-else class="no-selection">请勾选目录或选择素材</span>
          </el-form-item>
          <el-form-item label="已选素材（扁平打包）">
            <div class="download-materials-summary">
              <template v-if="downloadMaterialIds.length > 0">
                <el-tag v-for="id in downloadMaterialIds.slice(0, 5)" :key="id" size="mini" style="margin-right: 4px">{{ id }}</el-tag>
                <span v-if="downloadMaterialIds.length > 5" class="more-tag">等 {{ downloadMaterialIds.length }} 个</span>
              </template>
              <span v-else class="no-selection">未选择素材，可在列表中勾选后再点击下载</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadDialogVisible = false">取消</el-button>
        <el-button type="primary" icon="el-icon-download" :loading="downloading" @click="submitDownload">确认下载</el-button>
      </div>
    </el-dialog>

    <!-- 引用明细弹窗 -->
    <el-dialog
      :title="'引用明细：' + (refDetailMaterialName || '')"
      :visible.sync="refDetailDialogVisible"
      width="420px"
      append-to-body
      custom-class="beauty-dialog"
    >
      <el-table :data="refDetailList" border size="small" max-height="320" v-loading="refDetailLoading">
        <el-table-column prop="folderPath" label="文件夹路径" min-width="200" show-overflow-tooltip />
        <el-table-column prop="referenceCount" label="引用次数" width="100" align="center" />
        <el-table-column prop="lastReferencedAt" label="最后引用" width="160" align="center">
          <template slot-scope="{ row }">
            {{ row.lastReferencedAt ? parseTime(row.lastReferencedAt) : '-' }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <batch-derive-dialog
      :visible.sync="batchDeriveDialogVisible"
      :materials="selection"
      :tag-options="tagOptions"
      :folder-tree="folderTree"
      @success="onBatchDeriveSuccess"
    />
  </div>
</template>

<script>
import { listMaterials, uploadMaterial, updateMaterial, deleteMaterial, batchDeleteMaterials, batchUpdateMaterialFolder, batchRemoveFromFolder, batchAddMaterialTags, createDownloadTask, getDownloadPreview, checkMaterialNames, reuseExistingMaterials, getMaterialFolderReferences, getUploadSignature, uploadCallbackCos, updateMaterialTags } from '@/api/material/material';
import { captureVideoFirstFrame, isVideoFile } from '@/utils/videoThumbnail';
import { uploadToCos } from '@/utils/cosDirectUpload';
import { listTags } from '@/api/material/tag';
import { listFolderTree, createFolder, updateFolder, deleteFolder, moveFolder, batchTagFolder } from '@/api/material/folder';
import Pagination from "@/components/Pagination";
import RightToolbar from "@/components/RightToolbar";
import TableOperations from "@/components/TableOperations";
import BatchDeriveDialog from '@/views/material/components/BatchDeriveDialog.vue';
import { withLocalDevLongRangeDateShortcuts } from '@/utils/dateRangePickerOptions';

export default {
  name: "Materials",
  components: { Pagination, RightToolbar, TableOperations, BatchDeriveDialog },
  data() {
    return {
      loading: true,
      showSearch: true,
      batchDeriveDialogVisible: false,
      viewMode: localStorage.getItem('material_view_mode') || 'list',
      materialList: [],
      tagOptions: [],
      total: 0,
      selection: [],
      // 文件夹
      folderLoading: false,
      folderTree: [],
      folderFilter: '',
      folderTreeProps: { children: 'children', label: 'name' },
      /** 文件夹树展开的节点 ID，刷新后保持展开状态 */
      expandedFolderIds: [0],
      folderTreeKey: 0,
      currentFolderId: 0,
      currentFolder: null,
      folderOptions: [],
      folderDialogVisible: false,
      folderDialogTitle: '新建文件夹',
      folderSaving: false,
      folderForm: {
        id: undefined,
        name: '',
        parentId: 0,
        sort: 0
      },
      folderRules: {
        name: [{ required: true, message: '请输入文件夹名称', trigger: 'blur' }]
      },
      folderMoveDialogVisible: false,
      folderMoveSaving: false,
      folderMoveOptions: [],
      folderMoveForm: {
        targetParentId: 0,
        includeChildren: true
      },
      folderTagDialogVisible: false,
      folderTagSaving: false,
      folderTagForm: {
        tagIds: [],
        mode: 'append'
      },
      batchTagDialogVisible: false,
      batchTagSaving: false,
      batchTagForm: {
        tagIds: [],
        mode: 'append'
      },
      moveDialogVisible: false,
      moveSaving: false,
      moveForm: {
        folderId: 0
      },
      moveFolderDropdownVisible: false,
      query: {
        name: undefined,
        type: undefined,
        tagIds: [],
        folderId: undefined,
        adCountMin: undefined,
        adCountMax: undefined,
        spendMin: undefined,
        spendMax: undefined,
        purchasesMin: undefined,
        purchasesMax: undefined,
        roiMin: undefined,
        roiMax: undefined,
        referenceCountMin: undefined,
        referenceCountMax: undefined,
        onlyWithConsumption: false,
        sortField: undefined,
        sortOrder: undefined,
        pageNo: 1,
        pageSize: 10
      },
      // 素材创建日期范围（yyyy-MM-dd）；本地开发含「近3年」快捷项
      createDateRange: [],
      createDatePickerOptions: withLocalDevLongRangeDateShortcuts([]),
      // 上传
      uploadDialogVisible: false,
      uploadFileList: [],
      uploadTags: [],
      uploading: false,
      uploadStep: 'select',       // 'select' | 'confirm' | 'uploading'
      uploadCheckLoading: false,
      uploadNewFiles: [],          // 校验后可上传的文件
      uploadDupFiles: [],          // 校验后重复的文件
      uploadProgressList: [],      // 上传进度列表 [{name, status, statusText}]
      uploadDoneCount: 0,
      uploadPercent: 0,
      uploadCurrentPercent: 0,     // 当前正在上传文件的字节进度（0-100）
      uploadPreviewLimit: 80,
      uploadProgressPreviewLimit: 120,
      // 编辑
      editDialogVisible: false,
      editTitle: '编辑素材',
      editForm: {},
      editRules: {
        name: [{ required: true, message: '素材名称不能为空', trigger: 'blur' }]
      },
      // 预览 / 文件详情
      previewDialogVisible: false,
      previewItem: null,
      detailZoomLevel: 1,
      // 下载
      downloadDialogVisible: false,
      downloading: false,
      downloadPreview: null,
      refDetailDialogVisible: false,
      refDetailLoading: false,
      refDetailList: [],
      refDetailMaterialName: ''
    };
  },
  computed: {
    /** 当前用户是否为 data_limited 角色（隐藏指标搜索和排序） */
    isDataLimited() {
      var appVm = this.$root && this.$root.$children && this.$root.$children[0];
      var user = appVm && appVm.currentUser;
      if (!user || !user.roleCodes) return false;
      return user.roleCodes.indexOf('data_limited') !== -1;
    },
    /** 已选中素材 ID 的 Set，O(1) 查找替代 Array.some O(n) */
    selectedIdSet() {
      return new Set(this.selection.map(s => s.id));
    },
    /** 已选图片数量（批量衍生按钮用） */
    selectedImageCount() {
      return (this.selection || []).filter(m => m && m.type === 'image').length;
    },
    /** 当前页是否已全选（卡片视图用） */
    isAllSelected() {
      return this.materialList.length > 0 && this.materialList.every(item => this.selectedIdSet.has(item.id));
    },
    /**
     * 标签颜色 → 对比色的缓存映射
     * 每次 tagOptions 变化才重新计算，避免在 v-for 里每次渲染都解析 hex
     */
    contrastColorCache() {
      const cache = {};
      const calc = (hex) => {
        if (!hex) return '#fff';
        const h = hex.replace('#', '');
        const r = parseInt(h.substr(0, 2), 16);
        const g = parseInt(h.substr(2, 2), 16);
        const b = parseInt(h.substr(4, 2), 16);
        return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5 ? '#000' : '#fff';
      };
      this.tagOptions.forEach(tag => {
        if (tag.color && !(tag.color in cache)) {
          cache[tag.color] = calc(tag.color);
        }
      });
      // 同时兼容素材自带 tag 颜色（tagOptions 未必包含所有）
      this.materialList.forEach(m => {
        (m.tags || []).forEach(tag => {
          if (tag.color && !(tag.color in cache)) {
            cache[tag.color] = calc(tag.color);
          }
        });
      });
      return cache;
    },
    /** 下载对话框用文件夹树（排除根节点） */
    downloadFolderTreeData() {
      const root = this.folderTree && this.folderTree[0];
      return root && root.children ? root.children : [];
    },
    /** 移动到文件夹对话框用树形数据 */
    moveFolderTreeData() {
      const root = this.folderTree && this.folderTree[0];
      return root && root.children ? root.children : [];
    },
    /** 新建/重命名文件夹时的父级树（编辑模式下排除自身及子孙） */
    folderParentTreeData() {
      const root = this.folderTree && this.folderTree[0];
      const all = root && root.children ? root.children : [];
      if (!this.folderForm.id) return all;
      // 排除自身及子孙
      const excludeIds = new Set(this.collectDescendantIds(this.folderForm.id));
      excludeIds.add(this.folderForm.id);
      const filter = (list) => list
        .filter(n => !excludeIds.has(n.id))
        .map(n => ({ ...n, children: n.children ? filter(n.children) : [] }));
      return filter(all);
    },
    /** 当前勾选用于下载的素材 ID */
    downloadMaterialIds() {
      return this.selection.map(s => s.id);
    },
    /** 文件夹移动对话框树形数据（排除自身及子孙） */
    folderMoveTreeData() {
      const root = this.folderTree && this.folderTree[0];
      const all = root && root.children ? root.children : [];
      if (!this.currentFolderId) return all;
      const excludeIds = new Set(this.collectDescendantIds(this.currentFolderId));
      excludeIds.add(this.currentFolderId);
      const filter = (list) => list
        .filter(n => !excludeIds.has(n.id))
        .map(n => ({ ...n, children: n.children ? filter(n.children) : [] }));
      return filter(all);
    },
    /** 上传总处理数（新上传 + 重复复用） */
    uploadProcessTotal() {
      return this.uploadNewFiles.length + this.uploadDupFiles.length;
    },
    /** 上传进度条状态：完成且有失败时显示异常 */
    uploadProgressStatus() {
      if (this.uploadPercent < 100) return '';
      const hasError = this.uploadProgressList.some(item => item.status === 'error');
      return hasError ? 'exception' : 'success';
    },
    /** 大批量时仅展示部分文件，避免弹窗卡顿 */
    uploadNewFilesPreview() {
      return this.uploadNewFiles.slice(0, this.uploadPreviewLimit);
    },
    uploadDupFilesPreview() {
      return this.uploadDupFiles.slice(0, this.uploadPreviewLimit);
    },
    uploadProgressPreview() {
      return this.uploadProgressList.slice(0, this.uploadProgressPreviewLimit);
    },
    uploadNewHiddenCount() {
      return Math.max(0, this.uploadNewFiles.length - this.uploadNewFilesPreview.length);
    },
    uploadDupHiddenCount() {
      return Math.max(0, this.uploadDupFiles.length - this.uploadDupFilesPreview.length);
    },
    uploadProgressHiddenCount() {
      return Math.max(0, this.uploadProgressList.length - this.uploadProgressPreview.length);
    },
    /**
     * 当前选中文件夹的完整路径（面包屑式），如 "FB素材 / 2026-02-09"
     */
    currentFolderPath() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        return '全部素材';
      }
      const tree = (this.folderTree && this.folderTree[0] && this.folderTree[0].children) || [];
      const pathArr = this.buildFolderPath(tree, this.currentFolderId, []);
      if (pathArr && pathArr.length > 0) {
        return pathArr.join(' / ');
      }
      return this.currentFolder && this.currentFolder.name ? this.currentFolder.name : '全部素材';
    }
  },
  watch: {
    downloadMaterialIds() {
      if (this.downloadDialogVisible) this.fetchDownloadPreview();
    },
    // 切换到列表视图时，把卡片视图的已选同步给 el-table；同时持久化视图模式
    viewMode(val) {
      localStorage.setItem('material_view_mode', val);
      if (val === 'list') {
        this.syncTableSelection();
      }
    },
    // 列表数据刷新后，列表视图下重放勾选状态
    materialList() {
      if (this.viewMode === 'list') {
        this.syncTableSelection();
      }
    }
  },
  created() {
    this.fetchFolders();
    this.fetchList();
    this.fetchTags();
  },
  mounted() {
    // 框选：用原生事件绑定，完全绕开 Vue 模板事件和 v-loading 遮罩问题
    this._dragBox = document.createElement('div');
    Object.assign(this._dragBox.style, {
      position: 'fixed', border: 'none',
      background: 'transparent', borderRadius: '3px',
      pointerEvents: 'none', zIndex: '9999', display: 'none'
    });
    document.body.appendChild(this._dragBox);

    this._nativeMouseDown = (e) => {
      if (e.button !== 0) return;
      // 用 data 属性找 grid，不依赖 $refs（避免 v-loading 包装层问题）
      const grid = document.querySelector('[data-material-grid]');
      if (!grid) return;
      if (!grid.contains(e.target)) return;
      // 仅屏蔽操作按钮点击，不屏蔽卡片媒体区域点击/拖拽
      if (e.target.closest('.media-overlay .el-button')) return;

      const startClientX = e.clientX;
      const startClientY = e.clientY;
      let lastClientX = startClientX;
      let lastClientY = startClientY;
      let isDrag = false;
      let baseIds = null;
      let rafId = null;

      const getScrollContainer = (el) => {
        let node = el;
        while (node && node !== document.body && node !== document.documentElement) {
          const style = window.getComputedStyle(node);
          const overflowY = style.overflowY;
          if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
            return node;
          }
          node = node.parentElement;
        }
        return window;
      };

      const scrollContainer = getScrollContainer(grid);

      const getContainerMetrics = () => {
        if (scrollContainer === window) {
          return {
            left: 0,
            top: 0,
            scrollLeft: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
            scrollTop: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
          };
        }
        const rect = scrollContainer.getBoundingClientRect();
        return {
          left: rect.left,
          top: rect.top,
          scrollLeft: scrollContainer.scrollLeft,
          scrollTop: scrollContainer.scrollTop
        };
      };

      const toContainerPoint = (clientX, clientY) => {
        const metrics = getContainerMetrics();
        return {
          x: clientX - metrics.left + metrics.scrollLeft,
          y: clientY - metrics.top + metrics.scrollTop
        };
      };

      const startPoint = toContainerPoint(startClientX, startClientY);

      // 找起始卡片（单击用）—— 用 String 比较避免类型问题
      const clickCard = e.target.closest('[data-id]');

      const updateSelection = (clientX, clientY) => {
        const currentPoint = toContainerPoint(clientX, clientY);
        const dx = Math.abs(currentPoint.x - startPoint.x);
        const dy = Math.abs(currentPoint.y - startPoint.y);
        if (dx < 5 && dy < 5) return;
        isDrag = true;

        if (!baseIds) {
          baseIds = new Set(this.selection.map(s => String(s.id)));
        }

        const l = Math.min(startPoint.x, currentPoint.x);
        const t = Math.min(startPoint.y, currentPoint.y);
        const w = Math.abs(currentPoint.x - startPoint.x);
        const h = Math.abs(currentPoint.y - startPoint.y);

        // 碰撞检测 —— 在滚动容器坐标系内进行，避免滚动导致错选
        const cards = (document.querySelector('[data-material-grid]') || grid).querySelectorAll('[data-id]');
        const hitIds = new Set();
        const metrics = getContainerMetrics();
        cards.forEach(card => {
          const r = card.getBoundingClientRect();
          const cardLeft = r.left - metrics.left + metrics.scrollLeft;
          const cardTop = r.top - metrics.top + metrics.scrollTop;
          const cardRight = cardLeft + r.width;
          const cardBottom = cardTop + r.height;
          if (l < cardRight && l + w > cardLeft && t < cardBottom && t + h > cardTop) {
            hitIds.add(String(card.dataset.id));
          }
        });

        this.selection = this.materialList.filter(m =>
          baseIds.has(String(m.id)) || hitIds.has(String(m.id))
        );
      };

      const scheduleUpdate = () => {
        if (rafId !== null) return;
        rafId = window.requestAnimationFrame(() => {
          rafId = null;
          updateSelection(lastClientX, lastClientY);
        });
      };

      const onMove = (ev) => {
        lastClientX = ev.clientX;
        lastClientY = ev.clientY;
        updateSelection(lastClientX, lastClientY);
      };

      const onScroll = () => {
        // 拖拽中滚动时，鼠标可能静止，但需要重算碰撞区
        scheduleUpdate();
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        if (scrollContainer === window) {
          window.removeEventListener('scroll', onScroll);
        } else {
          scrollContainer.removeEventListener('scroll', onScroll);
        }

        if (rafId !== null) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
        }

        if (!isDrag && clickCard) {
          const id = String(clickCard.dataset.id);
          const item = this.materialList.find(m => String(m.id) === id);
          if (item) this.toggleSelect(item);
        }
        baseIds = null;
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      if (scrollContainer === window) {
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        scrollContainer.addEventListener('scroll', onScroll, { passive: true });
      }
    };

    document.addEventListener('mousedown', this._nativeMouseDown);
  },
  beforeDestroy() {
    if (this._nativeMouseDown) document.removeEventListener('mousedown', this._nativeMouseDown);
    if (this._dragBox && this._dragBox.parentNode) this._dragBox.parentNode.removeChild(this._dragBox);
  },
  methods: {
    buildQueryParams() {
      const params = { ...this.query };
      if (Array.isArray(this.createDateRange) && this.createDateRange.length === 2) {
        params.createTimeStart = this.createDateRange[0];
        params.createTimeEnd = this.createDateRange[1];
      } else {
        params.createTimeStart = undefined;
        params.createTimeEnd = undefined;
      }
      if (Array.isArray(params.tagIds) && params.tagIds.includes(-1)) {
        params.noTags = true;
        params.tagIds = undefined;
      }
      return params;
    },
    handleTagSelectChange(val) {
      if (!Array.isArray(val)) return;
      if (val.includes(-1) && val.length > 1) {
        this.query.tagIds = [-1];
      }
    },
    async fetchList() {
      this.loading = true;
      try {
        const response = await listMaterials(this.buildQueryParams());
        this.materialList = response.data.records || response.data || [];
        this.total = response.data.total || this.materialList.length;
      } finally {
        this.loading = false;
      }
    },
    async fetchTags() {
      try {
        const response = await listTags({ pageSize: 1000 });
        this.tagOptions = response.data.records || response.data || [];
      } catch (e) {
        console.error('Failed to fetch tags', e);
      }
    },
    async fetchFolders() {
      this.folderLoading = true;
      try {
        const response = await listFolderTree({ filterByOwner: true });
        const tree = response.data || [];
        this.folderTree = [{
          id: 0,
          name: '全部素材',
          parentId: null,
          children: tree
        }];
        if (this.currentFolderId === 0 && this.folderTree.length) {
          this.currentFolder = this.folderTree[0];
        } else if (this.currentFolderId) {
          const found = this.findFolderById(tree, this.currentFolderId);
          if (found) {
            this.currentFolder = found;
          } else {
            this.currentFolderId = 0;
            this.currentFolder = this.folderTree[0];
            this.query.folderId = undefined;
          }
        }
        this.folderOptions = this.flattenFolderOptions(tree);
        this.folderTreeKey += 1;
        this.refreshFolderSelection();
      } finally {
        this.folderLoading = false;
      }
    },
    refreshFolderSelection() {
      this.$nextTick(() => {
        if (this.$refs.folderTree) {
          this.$refs.folderTree.setCurrentKey(this.currentFolderId);
        }
      });
    },
    flattenFolderOptions(list, level = 0, result = []) {
      list.forEach(item => {
        const prefix = level > 0 ? `${'--'.repeat(level)} ` : '';
        result.push({ id: item.id, label: `${prefix}${item.name}` });
        if (item.children && item.children.length) {
          this.flattenFolderOptions(item.children, level + 1, result);
        }
      });
      return result;
    },
    findFolderById(list, id) {
      for (const item of list) {
        if (item.id === id) return item;
        if (item.children && item.children.length) {
          const found = this.findFolderById(item.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    /**
     * 构建从根节点到目标节点的完整路径
     * @param list 树列表
     * @param targetId 目标节点ID
     * @param path 当前路径链
     * @return 路径数组，如 ["首一级", "FB素材", "2026-02-09"];未找到返回 null
     */
    buildFolderPath(list, targetId, path) {
      if (!path) path = [];
      for (const item of list) {
        const currentPath = [...path, item.name];
        if (item.id === targetId) return currentPath;
        if (item.children && item.children.length) {
          const found = this.buildFolderPath(item.children, targetId, currentPath);
          if (found) return found;
        }
      }
      return null;
    },
    handleFolderFilter(value) {
      if (this.$refs.folderTree) {
        this.$refs.folderTree.filter(value);
      }
    },
    filterFolderNode(value, data) {
      if (!value) return true;
      return data.name && data.name.includes(value);
    },
    handleFolderSelect(node) {
      this.currentFolderId = node.id;
      this.currentFolder = node;
      this.query.folderId = node.id === 0 ? undefined : node.id;
      this.selection = [];
      this.handleQuery();
    },
    handleFolderNodeExpand(data) {
      if (data && data.id !== undefined && !this.expandedFolderIds.includes(data.id)) {
        this.expandedFolderIds = [...this.expandedFolderIds, data.id];
      }
    },
    handleFolderNodeCollapse(data) {
      if (data && data.id !== undefined) {
        this.expandedFolderIds = this.expandedFolderIds.filter(id => id !== data.id);
      }
    },
    allowFolderDrag(draggingNode) {
      return draggingNode && draggingNode.data && draggingNode.data.id !== 0;
    },
    allowFolderDrop(draggingNode, dropNode, type) {
      if (!draggingNode || !dropNode) return false;
      if (type !== 'inner') return false;
      const dragId = draggingNode.data && draggingNode.data.id;
      const dropId = dropNode.data && dropNode.data.id;
      if (!dragId || dropId === undefined || dropId === null) return false;
      if (dragId === dropId) return false;
      if (dropId === 0) return true;
      if (this.isDescendant(dragId, dropId)) return false;
      return true;
    },
    async handleFolderDrop(draggingNode, dropNode) {
      const dragId = draggingNode.data.id;
      const dropId = dropNode.data.id;
      const newParentId = dropId === 0 ? null : dropId;
      const oldParentId = draggingNode.data.parentId || null;
      if (oldParentId === newParentId) {
        return;
      }
      this.folderLoading = true;
      try {
        await updateFolder(dragId, {
          id: dragId,
          name: draggingNode.data.name,
          parentId: newParentId,
          sort: draggingNode.data.sort || 0
        });
        this.$message.success('移动成功');
        await this.fetchFolders();
      } catch (e) {
        await this.fetchFolders();
      } finally {
        this.folderLoading = false;
      }
    },
    isDescendant(parentId, targetId) {
      const root = (this.folderTree && this.folderTree[0] && this.folderTree[0].children) || [];
      const node = this.findFolderById(root, parentId);
      if (!node) return false;
      const stack = [...(node.children || [])];
      while (stack.length) {
        const current = stack.pop();
        if (current.id === targetId) return true;
        if (current.children && current.children.length) {
          stack.push(...current.children);
        }
      }
      return false;
    },
    handleFolderCreate() {
      this.folderDialogTitle = '新建文件夹';
      this.folderForm = {
        id: undefined,
        name: '',
        parentId: this.currentFolderId > 0 ? this.currentFolderId : 0,
        sort: 0
      };
      this.folderDialogVisible = true;
    },
    handleFolderRename() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        this.$message.warning('请选择需要操作的文件夹');
        return;
      }
      this.folderDialogTitle = '重命名文件夹';
      this.folderForm = {
        id: this.currentFolderId,
        name: this.currentFolder.name,
        parentId: this.currentFolder.parentId || 0,
        sort: this.currentFolder.sort || 0
      };
      this.folderDialogVisible = true;
    },
    handleFolderDelete() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        this.$message.warning('请选择需要操作的文件夹');
        return;
      }
      this.$confirm('确认删除该文件夹吗？删除后仅移除文件夹及其子文件夹，素材不会删除（仅移除该文件夹映射）。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteFolder(this.currentFolderId);
        this.currentFolderId = 0;
        this.currentFolder = null;
        this.query.folderId = undefined;
        this.fetchFolders();
        this.fetchList();
        this.$message.success('删除成功');
      }).catch(() => {});
    },
    handleFolderMove() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        this.$message.warning('请选择需要操作的文件夹');
        return;
      }
      const excludeIds = new Set(this.collectDescendantIds(this.currentFolderId));
      excludeIds.add(this.currentFolderId);
      this.folderMoveOptions = this.folderOptions.filter(item => !excludeIds.has(item.id));
      this.folderMoveForm = {
        targetParentId: this.currentFolder.parentId || 0,
        includeChildren: true
      };
      this.folderMoveDialogVisible = true;
    },
    async submitFolderMove() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        this.$message.warning('请选择需要操作的文件夹');
        return;
      }
      const targetValue = Number(this.folderMoveForm.targetParentId);
      const newParentId = Number.isFinite(targetValue) && targetValue > 0 ? targetValue : null;
      const oldParentId = this.currentFolder.parentId || null;
      if (newParentId === oldParentId) {
        this.$message.warning('目标文件夹未变化');
        return;
      }
      this.folderMoveSaving = true;
      try {
        await moveFolder(this.currentFolderId, {
          targetParentId: newParentId,
          includeChildren: this.folderMoveForm.includeChildren
        });
        this.$message.success('移动成功');
        await this.fetchFolders();
      } catch (e) {
        const message = e?.response?.data?.message || '移动失败';
        this.$message.error(message);
      } finally {
        this.folderMoveSaving = false;
        this.folderMoveDialogVisible = false;
      }
    },
    handleFolderBatchTag() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        this.$message.warning('请选择需要操作的文件夹');
        return;
      }
      this.folderTagForm = {
        tagIds: [],
        mode: 'append'
      };
      this.folderTagDialogVisible = true;
    },
    async submitFolderBatchTag() {
      if (!this.currentFolderId || this.currentFolderId === 0) {
        this.$message.warning('请选择需要操作的文件夹');
        return;
      }
      if (!this.folderTagForm.tagIds || this.folderTagForm.tagIds.length === 0) {
        this.$message.warning('请选择要添加的标签');
        return;
      }
      this.folderTagSaving = true;
      try {
        await batchTagFolder(this.currentFolderId, this.folderTagForm.tagIds, this.folderTagForm.mode);
        this.$message.success('打标签成功');
        this.folderTagDialogVisible = false;
        await this.fetchList();
      } finally {
        this.folderTagSaving = false;
      }
    },
    submitFolder() {
      this.$refs.folderFormRef.validate(async valid => {
        if (!valid) return;
        this.folderSaving = true;
        try {
          const payload = {
            ...this.folderForm,
            parentId: this.folderForm.parentId === 0 ? null : this.folderForm.parentId
          };
          if (payload.id) {
            await updateFolder(payload.id, payload);
            this.$message.success('修改成功');
          } else {
            await createFolder(payload);
            this.$message.success('创建成功');
            const parentId = this.folderForm.parentId || 0;
            if (parentId && !this.expandedFolderIds.includes(parentId)) {
              this.expandedFolderIds = [...this.expandedFolderIds, parentId];
            }
          }
          this.folderDialogVisible = false;
          this.fetchFolders();
        } finally {
          this.folderSaving = false;
        }
      });
    },
    collectDescendantIds(folderId) {
      const root = (this.folderTree && this.folderTree[0] && this.folderTree[0].children) || [];
      const node = this.findFolderById(root, folderId);
      if (!node || !node.children || node.children.length === 0) {
        return [];
      }
      const result = [];
      const stack = [...node.children];
      while (stack.length) {
        const current = stack.pop();
        result.push(current.id);
        if (current.children && current.children.length) {
          stack.push(...current.children);
        }
      }
      return result;
    },
    handleQuery() {
      this.query.pageNo = 1;
      this.selection = [];
      this.fetchList();
    },
    resetQuery() {
      const folderId = this.query.folderId;
      this.query = {
        name: undefined,
        type: undefined,
        tagIds: [],
        folderId,
        adCountMin: undefined,
        adCountMax: undefined,
        spendMin: undefined,
        spendMax: undefined,
        purchasesMin: undefined,
        purchasesMax: undefined,
        roiMin: undefined,
        roiMax: undefined,
        referenceCountMin: undefined,
        referenceCountMax: undefined,
        onlyWithConsumption: false,
        sortField: undefined,
        sortOrder: undefined,
        pageNo: 1,
        pageSize: 10
      };
      this.createDateRange = [];
      this.selection = [];
      this.handleQuery();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.query.pageNo = val;
      this.fetchList();
    },
    handleSortChange({ prop, order }) {
      if (prop && order) {
        this.query.sortField = prop;
        this.query.sortOrder = order === 'ascending' ? 'asc' : 'desc';
      } else {
        this.query.sortField = undefined;
        this.query.sortOrder = undefined;
      }
      this.query.pageNo = 1;
      this.fetchList();
    },
    toggleViewMode() {
      this.viewMode = this.viewMode === 'card' ? 'list' : 'card';
    },
    // 选择
    isSelected(id) {
      return this.selection.some(item => item.id === id);
    },
    toggleSelect(item) {
      const index = this.selection.findIndex(s => s.id === item.id);
      if (index > -1) {
        this.selection.splice(index, 1);
      } else {
        this.selection.push(item);
      }
    },
    /** 卡片视图全选 / 取消全选当前页 */
    handleToggleSelectAll() {
      if (this.isAllSelected) {
        const currentIds = new Set(this.materialList.map(m => m.id));
        this.selection = this.selection.filter(s => !currentIds.has(s.id));
      } else {
        const existingIds = new Set(this.selection.map(s => s.id));
        this.materialList.forEach(item => {
          if (!existingIds.has(item.id)) {
            this.selection.push(item);
          }
        });
      }
    },
    /** 素材展示名：优先素材名 name，其次原始文件名 */
    getDisplayName(item) {
      if (!item) return '';
      const name = item.name && String(item.name).trim();
      if (name) return name;
      return (item.originalName && String(item.originalName).trim()) || '';
    },
    /** 复制素材名称到剪贴板 */
    handleCopyName(name) {
      if (!name) return;
      const textarea = document.createElement('textarea');
      textarea.value = name;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message({ message: '已复制: ' + name, type: 'success', duration: 1500 });
      } catch (e) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(textarea);
    },
    syncTableSelection() {
      this.$nextTick(() => {
        const table = this.$refs.materialTable;
        if (!table) return;
        table.clearSelection();
        const selectedIds = new Set(this.selection.map(s => String(s.id)));
        this.materialList.forEach(row => {
          if (selectedIds.has(String(row.id))) {
            table.toggleRowSelection(row, true);
          }
        });
      });
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    // 上传
    handleUpload() {
      this.resetUploadDialog();
      this.uploadDialogVisible = true;
    },
    resetUploadDialog() {
      this.uploadFileList = [];
      this.uploadTags = [];
      this.uploadStep = 'select';
      this.uploadCheckLoading = false;
      this.uploadNewFiles = [];
      this.uploadDupFiles = [];
      this.uploadProgressList = [];
      this.uploadDoneCount = 0;
      this.uploadPercent = 0;
      this.uploadCurrentPercent = 0;
    },
    handleFileChange(file, fileList) {
      // 过滤本批次内同名文件，仅保留每个文件名第一次出现的文件
      const seen = new Set();
      this.uploadFileList = fileList.filter(f => {
        const name = f.name || (f.raw && f.raw.name);
        if (seen.has(name)) return false;
        seen.add(name);
        return true;
      });
    },
    handleFileRemove(file, fileList) {
      this.uploadFileList = fileList;
    },
    // 点击"下一步"：批量校验文件名
    async goCheckNames() {
      if (this.uploadFileList.length === 0) return;
      this.uploadStep = 'confirm';
      this.uploadCheckLoading = true;
      try {
        const names = this.uploadFileList.map(f => f.name);
        const res = await checkMaterialNames(names, this.currentFolderId > 0 ? this.currentFolderId : null);
        const checkList = res.data || [];
        const checkMap = new Map(checkList.map(item => [item.fileName, item]));
        this.uploadNewFiles = this.uploadFileList.filter(f => {
          const hit = checkMap.get(f.name);
          return !(hit && hit.exists);
        });
        this.uploadDupFiles = this.uploadFileList
          .filter(f => {
            const hit = checkMap.get(f.name);
            return !!(hit && hit.exists);
          })
          .map(f => {
            const hit = checkMap.get(f.name) || {};
            return {
              ...f,
              materialId: hit.materialId,
              linkedToCurrentFolder: !!hit.linkedToCurrentFolder
            };
          });
      } catch (e) {
        this.$message.error('文件名校验失败，请重试');
        this.uploadStep = 'select';
      } finally {
        this.uploadCheckLoading = false;
      }
    },
    // 开始逐个上传
    async startUpload() {
      if (this.uploadProcessTotal === 0) return;
      this.uploadStep = 'uploading';
      this.uploadDoneCount = 0;
      this.uploadPercent = 0;
      this.uploadCurrentPercent = 0;
      const dupFiles = this.uploadDupFiles || [];
      const newFiles = this.uploadNewFiles || [];
      this.uploadProgressList = [
        ...dupFiles.map(f => ({
          name: f.name,
          status: 'pending',
          statusText: '等待复用'
        })),
        ...newFiles.map(f => ({
          name: f.name,
          status: 'pending',
          statusText: '等待上传'
        }))
      ];

      const total = this.uploadProgressList.length;
      let successCount = 0;
      let reusedCount = 0;
      const refreshProgress = () => {
        const currentUploading = this.uploadCurrentPercent > 0 ? (this.uploadCurrentPercent / 100) : 0;
        const progressed = this.uploadDoneCount + currentUploading;
        this.uploadPercent = total === 0 ? 100 : Math.min(100, Math.round((progressed / total) * 100));
      };

      // 1) 先批量复用重复素材（关联到当前目录 + 追加标签）
      if (dupFiles.length > 0) {
        const validDupIndexes = [];
        const validDupMaterialIds = [];
        dupFiles.forEach((file, index) => {
          if (file.materialId) {
            validDupIndexes.push(index);
            validDupMaterialIds.push(file.materialId);
            this.$set(this.uploadProgressList, index, { name: file.name, status: 'uploading', statusText: '复用中…' });
          } else {
            this.$set(this.uploadProgressList, index, { name: file.name, status: 'error', statusText: '未找到可复用素材' });
            this.uploadDoneCount++;
          }
        });
        refreshProgress();

        if (validDupMaterialIds.length > 0) {
          try {
            await reuseExistingMaterials(
              validDupMaterialIds,
              this.currentFolderId > 0 ? this.currentFolderId : null,
              this.uploadTags || []
            );
            validDupIndexes.forEach(index => {
              const file = dupFiles[index];
              const doneText = this.currentFolderId > 0
                ? (file.linkedToCurrentFolder ? '已在当前目录' : '已复用并关联目录')
                : '已复用';
              this.$set(this.uploadProgressList, index, { name: file.name, status: 'done', statusText: doneText });
              this.uploadDoneCount++;
              reusedCount++;
            });
          } catch (err) {
            const msg = this.resolveUploadErrorMessage(err, '复用失败');
            validDupIndexes.forEach(index => {
              const file = dupFiles[index];
              this.$set(this.uploadProgressList, index, { name: file.name, status: 'error', statusText: msg });
              this.uploadDoneCount++;
            });
          }
          refreshProgress();
        }
      }

      // 2) 再上传新增文件 —— 优先使用 COS 直传，避免大文件经过 nginx/后端中转被 413 拦截
      const offset = dupFiles.length;

      // 尝试获取 COS 直传签名（如果后端未配置 COS，自动回退到后端中转上传）
      let cosSignature = null;
      try {
        const sigRes = await getUploadSignature(this.currentFolderId > 0 ? this.currentFolderId : null);
        const sigData = (sigRes && sigRes.data) ? sigRes.data : sigRes;
        if (sigData && sigData.cosHost && sigData.policy) {
          cosSignature = sigData;
        }
      } catch (e) {
        console.warn('COS 直传签名获取失败，回退到后端中转上传:', e.message || e);
      }

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const progressIndex = offset + i;
        this.uploadCurrentPercent = 0;
        this.$set(this.uploadProgressList, progressIndex, { name: file.name, status: 'uploading', statusText: '上传中…0%' });
        refreshProgress();

        try {
          if (cosSignature) {
            // ── COS 直传模式 ──
            const nameParts = file.name.split('.');
            const ext = nameParts.length > 1 ? ('.' + nameParts.pop().toLowerCase()) : '';
            const uuid = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/x/g, () =>
              Math.floor(Math.random() * 16).toString(16)
            );
            const objectKey = cosSignature.dir + uuid + ext;
            const onCosProgress = (evt) => {
              if (!evt || !evt.total) return;
              const percent = Math.max(0, Math.min(100, Math.round((evt.loaded / evt.total) * 100)));
              if (percent === this.uploadCurrentPercent) return;
              this.uploadCurrentPercent = percent;
              this.$set(this.uploadProgressList, progressIndex, {
                name: file.name,
                status: 'uploading',
                statusText: `上传中…${percent}%`
              });
              refreshProgress();
            };

            let thumbnailPath = null;
            if (isVideoFile(file.raw)) {
              this.$set(this.uploadProgressList, progressIndex, {
                name: file.name,
                status: 'uploading',
                statusText: '生成封面…'
              });
              refreshProgress();
              try {
                const thumbBlob = await captureVideoFirstFrame(file.raw);
                thumbnailPath = cosSignature.dir + uuid + '_thumb.jpg';
                const thumbFile = new File([thumbBlob], uuid + '_thumb.jpg', { type: 'image/jpeg' });
                await uploadToCos(cosSignature, thumbnailPath, thumbFile);
              } catch (thumbErr) {
                console.warn('前端生成视频封面失败，将由服务端兜底:', thumbErr);
                thumbnailPath = null;
              }
            }

            await uploadToCos(cosSignature, objectKey, file.raw, onCosProgress);

            // 通知后端保存素材记录
            const fileUrl = 'https://' + cosSignature.cosHost + '/' + objectKey;
            const callbackPayload = {
              fileName: file.name,
              originalName: file.name,
              filePath: objectKey,
              fileUrl: fileUrl,
              fileSize: file.raw.size,
              fileType: file.raw.type || 'application/octet-stream',
              folderId: this.currentFolderId > 0 ? this.currentFolderId : null
            };
            if (thumbnailPath) {
              callbackPayload.thumbnailPath = thumbnailPath;
            }
            const callbackRes = await uploadCallbackCos([callbackPayload]);

            // 追加标签
            const savedList = (callbackRes && callbackRes.data) ? callbackRes.data : callbackRes;
            const saved = Array.isArray(savedList) && savedList.length > 0 ? savedList[0] : null;
            if (saved && saved.id && this.uploadTags && this.uploadTags.length > 0) {
              await updateMaterialTags(saved.id, this.uploadTags).catch(() => {});
            }

          } else {
            // ── 回退：后端中转上传 ──
            const formData = new FormData();
            formData.append('file', file.raw);
            formData.append('tagIds', this.uploadTags.join(','));
            if (this.currentFolderId > 0) {
              formData.append('folderIds', this.currentFolderId);
            }
            await uploadMaterial(formData, {
              onUploadProgress: (evt) => {
                if (!evt || !evt.total) return;
                const percent = Math.max(0, Math.min(100, Math.round((evt.loaded / evt.total) * 100)));
                if (percent === this.uploadCurrentPercent) return;
                this.uploadCurrentPercent = percent;
                this.$set(this.uploadProgressList, progressIndex, {
                  name: file.name,
                  status: 'uploading',
                  statusText: `上传中…${percent}%`
                });
                refreshProgress();
              }
            });
          }

          successCount++;
          this.uploadCurrentPercent = 0;
          this.$set(this.uploadProgressList, progressIndex, { name: file.name, status: 'done', statusText: '上传成功' });
        } catch (err) {
          const msg = this.resolveUploadErrorMessage(err, '上传失败');
          this.uploadCurrentPercent = 0;
          this.$set(this.uploadProgressList, progressIndex, { name: file.name, status: 'error', statusText: msg });
        }
        this.uploadDoneCount++;
        refreshProgress();
      }

      if (successCount > 0 || reusedCount > 0) {
        await this.fetchList();
      }

      const failCount = this.uploadProgressList.filter(item => item.status === 'error').length;
      if (failCount > 0) {
        this.$message.warning(`处理完成：新增 ${successCount}，复用 ${reusedCount}，失败 ${failCount}`);
      } else {
        this.$message.success(`处理完成：新增 ${successCount}，复用 ${reusedCount}`);
      }
    },
    resolveUploadErrorMessage(err, fallbackText) {
      const fallback = fallbackText || '上传失败';
      if (!err) return fallback;
      const response = err.response;
      const data = response && response.data ? response.data : null;
      const serverMsg = data && (data.message || data.msg);
      if (serverMsg) return serverMsg;

      const status = response && response.status;
      if (status === 413) {
        return '上传失败：文件过大（网关或服务端限制）';
      }
      if (status === 502 || status === 504) {
        return '上传失败：网关超时，请稍后重试';
      }

      const msg = err.message || '';
      if (msg === 'Network Error') {
        return '上传失败：网络中断或网关提前断开（常见于大文件超限/超时）';
      }
      if (msg.includes('timeout')) {
        return '上传失败：请求超时，请稍后重试';
      }
      if (msg.includes('status code 413')) {
        return '上传失败：文件过大（网关或服务端限制）';
      }
      if (msg.includes('status code 502') || msg.includes('status code 504')) {
        return '上传失败：网关超时，请稍后重试';
      }
      return msg || fallback;
    },
    finishUpload() {
      this.uploadDialogVisible = false;
    },
    // 文件大小格式化
    formatFileSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    },
    // 编辑
    handleUpdate(row) {
      this.editForm = {
        id: row.id,
        name: row.name,
        folderIds: row.folderIds || [],
        tagIds: (row.tags || []).map(t => t.id)
      };
      this.editDialogVisible = true;
    },
    async submitEdit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          const payload = {
            ...this.editForm,
            folderIds: this.editForm.folderIds || []
          };
          await updateMaterial(this.editForm.id, payload);
          this.$message.success('修改成功');
          this.editDialogVisible = false;
          this.fetchList();
        }
      });
    },
    // 删除 / 从当前文件夹移除（根据视图上下文）
    handleDeleteOrRemove(row) {
      if (this.currentFolderId > 0) {
        this.$confirm('是否从当前文件夹移除该素材？（仅解除引用，素材仍存在于其他文件夹）', '移除引用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await batchRemoveFromFolder([row.id], this.currentFolderId);
          this.fetchList();
          this.$message.success('已从当前文件夹移除');
        }).catch(() => {});
      } else {
        this.$confirm('是否确认删除该素材？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await deleteMaterial(row.id);
          this.fetchList();
          this.$message.success('删除成功');
        }).catch(() => {});
      }
    },
    handleBatchDeleteOrRemove() {
      if (this.selection.length === 0) return;
      if (this.currentFolderId > 0) {
        this.$confirm(`是否从当前文件夹移除选中的 ${this.selection.length} 个素材？（仅解除引用，素材仍存在于其他文件夹）`, '移除引用', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const ids = this.selection.map(item => item.id);
          await batchRemoveFromFolder(ids, this.currentFolderId);
          this.selection = [];
          this.fetchList();
          this.$message.success('已从当前文件夹移除');
        }).catch(() => {});
      } else {
        this.$confirm(`是否确认删除选中的 ${this.selection.length} 个素材？`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const ids = this.selection.map(item => item.id);
          await batchDeleteMaterials(ids);
          this.selection = [];
          this.fetchList();
          this.$message.success('删除成功');
        }).catch(() => {});
      }
    },
    handleBatchMove() {
      if (this.selection.length === 0) return;
      this.moveForm.folderId = this.currentFolderId > 0 ? this.currentFolderId : 0;
      this.moveFolderDropdownVisible = false;
      this.moveDialogVisible = true;
    },
    getMoveTargetLabel() {
      if (this.moveForm.folderId === 0 || this.moveForm.folderId === null || this.moveForm.folderId === undefined) {
        return '未归档';
      }
      const found = this.folderOptions.find(f => f.id === this.moveForm.folderId);
      return found ? found.label.replace(/^[-\s]+/, '') : '未归档';
    },
    getFolderName(id) {
      const found = this.folderOptions.find(f => f.id === id);
      return found ? found.label.replace(/^[-\s]+/, '') : '';
    },
    selectMoveFolder(id) {
      this.moveForm.folderId = id;
      this.moveFolderDropdownVisible = false;
    },
    onMoveFolderTreeClick(data) {
      this.moveForm.folderId = data.id;
      this.moveFolderDropdownVisible = false;
    },
    async submitMove() {
      if (this.selection.length === 0) return;
      this.moveSaving = true;
      try {
        const ids = this.selection.map(item => item.id);
        const folderId = this.moveForm.folderId === 0 ? null : this.moveForm.folderId;
        await batchUpdateMaterialFolder(ids, folderId);
        this.moveDialogVisible = false;
        this.selection = [];
        this.fetchList();
        this.$message.success('移动成功');
      } finally {
        this.moveSaving = false;
      }
    },
    handleBatchTag() {
      if (this.selection.length === 0) {
        this.$message.warning('请选择要操作的素材');
        return;
      }
      this.batchTagForm = { tagIds: [], mode: 'append' };
      this.batchTagDialogVisible = true;
    },
    async submitBatchTag() {
      if (!this.batchTagForm.tagIds || this.batchTagForm.tagIds.length === 0) {
        this.$message.warning('请选择要添加的标签');
        return;
      }
      this.batchTagSaving = true;
      try {
        const ids = this.selection.map(item => item.id);
        await batchAddMaterialTags(ids, this.batchTagForm.tagIds, this.batchTagForm.mode);
        this.$message.success('批量打标签成功');
        this.batchTagDialogVisible = false;
        this.selection = [];
        this.fetchList();
      } finally {
        this.batchTagSaving = false;
      }
    },
    // 打开文件详情
    handlePreview(item) {
      this.previewItem = item;
      this.detailZoomLevel = 1;
      this.previewDialogVisible = true;
    },
    async handleShowRefDetail(row) {
      this.refDetailMaterialName = this.getDisplayName(row);
      this.refDetailList = [];
      this.refDetailDialogVisible = true;
      this.refDetailLoading = true;
      try {
        const folderId = this.query.folderId && this.query.folderId > 0 ? this.query.folderId : null;
        const res = await getMaterialFolderReferences(row.id, { folderId, skipErrorMessage: true });
        const list = (res && res.data != null ? res.data : res) || [];
        this.refDetailList = list.map(r => ({ ...r, folderPath: r.folderPath || r.folderName || '-' }));
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '加载引用明细失败');
      } finally {
        this.refDetailLoading = false;
      }
    },
    parseTime(time) {
      if (!time) return '';
      const normalized = typeof time === 'string' ? time.replace(' ', 'T') : time;
      const date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return String(time);
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, '0');
      const d = date.getDate().toString().padStart(2, '0');
      const h = date.getHours().toString().padStart(2, '0');
      const min = date.getMinutes().toString().padStart(2, '0');
      const s = date.getSeconds().toString().padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    closeDetailDialog() {
      this.previewDialogVisible = false;
      this.previewItem = null;
      this.detailZoomLevel = 1;
    },
    detailZoomIn() {
      this.detailZoomLevel = Math.min(+(this.detailZoomLevel + 0.2).toFixed(1), 4);
    },
    detailZoomOut() {
      this.detailZoomLevel = Math.max(+(this.detailZoomLevel - 0.2).toFixed(1), 0.2);
    },
    detailZoomReset() {
      this.detailZoomLevel = 1;
    },
    getDetailFolderName(folderId) {
      if (!folderId) return '根目录';
      const found = this.folderOptions.find(f => f.id === folderId);
      if (!found) return '未知文件夹';
      return found.label.replace(/^[-\s]+/, '');
    },
    formatDetailFileSize(bytes) {
      if (!bytes) return '-';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
      return (bytes / (1024 * 1024 * 1024)).toFixed(1) + ' GB';
    },
    formatDetailTime(timeStr) {
      if (!timeStr) return '-';
      const d = new Date(timeStr);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    formatDetailDuration(seconds) {
      if (!seconds) return '-';
      const m = Math.floor(seconds / 60);
      const s = seconds % 60;
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    },
    copyDetailLink(url) {
      if (!url) { this.$message.error('文件链接不可用'); return; }
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('链接已复制到剪贴板');
    },
    handleDetailDownload() {
      if (!this.previewItem || !this.previewItem.filePath) return;
      const link = document.createElement('a');
      link.href = this.previewItem.filePath;
      link.download = this.previewItem.name || 'download';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleDetailDelete() {
      if (!this.previewItem) return;
      this.$confirm('确定要删除该素材吗？此操作不可恢复。', '提示', { type: 'warning' }).then(() => {
        this.handleDelete(this.previewItem);
        this.closeDetailDialog();
      }).catch(() => {});
    },
    // 下载
    handleDownload() {
      this.downloadDialogVisible = true;
      this.downloadPreview = null;
      this.$nextTick(() => {
        if (this.$refs.downloadFolderTree) {
          this.$refs.downloadFolderTree.setCheckedKeys([]);
        }
        this.fetchDownloadPreview();
      });
    },
    /** 多选图片批量衍生 */
    handleBatchDerive() {
      const images = (this.selection || []).filter(m => m && m.type === 'image');
      if (!images.length) {
        this.$message.warning('请先勾选图片素材');
        return;
      }
      const nonImage = (this.selection || []).length - images.length;
      if (nonImage > 0) {
        this.$message.info(`已忽略 ${nonImage} 个非图片素材，将仅对 ${images.length} 张图片衍生`);
      }
      this.batchDeriveDialogVisible = true;
    },
    onBatchDeriveSuccess(batch) {
      this.$confirm(
        `衍生任务 #${batch && batch.id ? batch.id : ''} 已提交，可在「图片生成任务」中查看进度。是否现在前往？`,
        '提交成功',
        { type: 'success', confirmButtonText: '去查看', cancelButtonText: '继续留在本页' }
      ).then(() => {
        this.$router.push('/material/ai-generate-tasks');
      }).catch(() => {});
    },
    onDownloadFolderCheck() {
      this.fetchDownloadPreview();
    },
    async fetchDownloadPreview() {
      // 仅使用已勾选节点，不包含半选父节点（避免误带入整棵子树）
      const checked = this.$refs.downloadFolderTree ? this.$refs.downloadFolderTree.getCheckedKeys() : [];
      const folderIds = checked.filter(id => id !== 0);
      const materialIds = [...this.downloadMaterialIds];
      if (folderIds.length === 0 && materialIds.length === 0) {
        this.downloadPreview = null;
        return;
      }
      try {
        const res = await getDownloadPreview({ folderIds, materialIds });
        this.downloadPreview = res.data || res;
      } catch (e) {
        this.downloadPreview = null;
      }
    },
    async submitDownload() {
      // 仅使用已勾选节点，不包含半选父节点
      const checked = this.$refs.downloadFolderTree ? this.$refs.downloadFolderTree.getCheckedKeys() : [];
      const folderIds = checked.filter(id => id !== 0);
      const materialIds = [...this.downloadMaterialIds];

      if (folderIds.length === 0 && materialIds.length === 0) {
        this.$message.warning('请至少选择一个目录或素材');
        return;
      }
      this.downloading = true;
      try {
        await createDownloadTask({ folderIds, materialIds });
        this.downloadDialogVisible = false;
        this.$message.success('下载任务已创建，正在后台打包，请到 素材管理 > 下载任务 查看进度');
      } catch (e) {
        this.$message.error('创建下载任务失败：' + (e?.message || e?.response?.data?.message || '未知错误'));
      } finally {
        this.downloading = false;
      }
    },
    // 工具方法
    getContrastColor(hexColor) {
      if (!hexColor) return '#fff';
      const hex = hexColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? '#000' : '#fff';
    },
    formatMetricMoney(value) {
      if (value == null || value === '') return '-';
      const num = Number(value);
      if (Number.isNaN(num)) return '-';
      return num.toFixed(2);
    },
    formatMetricInt(value) {
      if (value == null || value === '') return '-';
      const num = Number(value);
      if (Number.isNaN(num)) return '-';
      return Math.trunc(num).toLocaleString();
    },
    formatMetricDecimal(value, scale = 4) {
      if (value == null || value === '') return '-';
      const num = Number(value);
      if (Number.isNaN(num)) return '-';
      return num.toFixed(scale);
    },
    formatSize(bytes) {
      if (!bytes) return '-';
      const units = ['B', 'KB', 'MB', 'GB'];
      let i = 0;
      while (bytes >= 1024 && i < units.length - 1) {
        bytes /= 1024;
        i++;
      }
      return bytes.toFixed(1) + ' ' + units[i];
    },
  }
};
</script>

<style scoped>
.app-container {
  padding: 0;
  height: 100%;
}

.material-layout {
  margin: 0;
  background: #f5f7fb;
  padding: 12px;
  border-radius: 12px;
  height: calc(100vh - 84px);
  display: flex;
  align-items: stretch;
  overflow: hidden;
}

.content-col {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  float: none !important;
}

.folder-col {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  float: none !important;
}

.material-layout .beauty-card {
  border: 1px solid #ebeef5;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(24, 38, 56, 0.06);
}

.folder-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.folder-card >>> .el-card__header {
  padding: 12px 14px;
  background: #fafcff;
  border-bottom: 1px solid #eef2f7;
  flex-shrink: 0;
}

.folder-card >>> .el-card__body {
  padding: 12px 12px 16px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.content-scroll-wrap {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  height: 100%;
}

.folder-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.folder-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #303133;
}

.folder-title i {
  color: #409EFF;
}

.folder-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.folder-actions-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}

.folder-actions-row--single {
  justify-content: flex-start;
}

.folder-actions-left,
.folder-actions-right {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
}

.folder-actions .el-button {
  padding: 5px 8px;
  border-radius: 8px;
}

.folder-filter {
  margin-bottom: 10px;
}

.folder-filter >>> .el-input__inner {
  border-radius: 8px;
  background: #f8fafc;
}

.folder-tree {
  margin-top: 6px;
}

.folder-tree >>> .el-tree-node__content {
  height: 32px;
  border-radius: 6px;
  padding: 0 6px;
  cursor: grab;
}

.folder-tree >>> .el-tree-node__content:hover {
  background: #f5f7fa;
}

.folder-tree >>> .el-tree-node.is-current > .el-tree-node__content {
  background: #ecf5ff;
  color: #409EFF;
  font-weight: 600;
}

.folder-tree >>> .el-tree-node__label {
  font-size: 13px;
}

.compact-query-form >>> .el-form-item,
.metrics-filter-row >>> .el-form-item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.compact-query-form >>> .el-form-item__label,
.metrics-filter-row >>> .el-form-item__label {
  font-size: 12px;
  padding-right: 4px;
}

.metric-input {
  width: 96px;
}

.material-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 4px 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #eef2f7;
}

.current-folder {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  background: #f5f7fa;
  color: #606266;
  font-size: 13px;
}

.current-folder i {
  color: #409EFF;
}

.current-folder span {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-switch >>> .el-button {
  border-radius: 8px;
  padding: 6px 10px;
}

.material-ops >>> .table-operations {
  margin-bottom: 12px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #fafbfc;
  border: 1px solid #f0f2f5;
}

.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tool-btn {
  font-size: 16px;
  padding: 8px;
  margin-left: 8px;
  color: #606266;
  border-color: transparent;
  background: transparent;
}
.tool-btn:hover {
  background: #ecf5ff;
  color: #409EFF;
}

/* 卡片视图 */
.material-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  min-height: 200px;
  position: relative;
  user-select: none;
}

.material-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eef2f7;
  box-shadow: 0 6px 18px rgba(24, 38, 56, 0.06);
  cursor: pointer;
  /* 只过渡实际动画属性，避免 all 触发全量 layout/paint */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  /* hover 有 transform，提前提升为合成层，避免主线程参与 */
  will-change: transform;
  position: relative;
}

.material-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.material-card.selected {
  border-color: #409EFF;
  box-shadow: 0 8px 22px rgba(64, 158, 255, 0.22);
}

.card-media {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
  background: #f5f7fa;
}

.card-media img,
.card-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.material-card:hover .media-overlay {
  opacity: 1;
  pointer-events: auto;
}

.type-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.selected-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #409EFF;
  color: #fff;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-info {
  padding: 12px;
}

.card-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.card-name:hover {
  color: #409EFF;
}

.card-name-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-name-copy-icon {
  flex-shrink: 0;
  font-size: 13px;
  opacity: 0;
  transition: opacity 0.2s;
  color: #409EFF;
}

.card-name:hover .card-name-copy-icon {
  opacity: 1;
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  min-height: 22px;
}

.card-metrics {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #606266;
}

.metric-item {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 2px 6px;
}

.tag-item {
  margin-right: 4px;
  margin-bottom: 4px;
}

.more-tags {
  font-size: 12px;
  color: #909399;
}

.empty-state {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #909399;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
}

/* 列表视图 */
.table-thumb {
  width: 52px;
  height: 38px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.table-name-copy {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
}

.table-name-copy:hover {
  color: #409EFF;
}

.table-name-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.table-name-copy-icon {
  flex-shrink: 0;
  font-size: 13px;
  opacity: 0;
  transition: opacity 0.2s;
  color: #409EFF;
}

.table-name-copy:hover .table-name-copy-icon {
  opacity: 1;
}

.ref-count-link {
  cursor: pointer;
  color: #409EFF;
}
.ref-count-link:hover {
  text-decoration: underline;
}

.pagination-container {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}

/* 上传 */
.upload-area {
  width: 100%;
}

.upload-current-folder {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  color: #606266;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.upload-current-folder-tip {
  color: #909399;
  font-size: 12px;
}

.upload-form {
  margin-top: 20px;
}

/* 校验确认步骤 */
.upload-confirm {
  min-height: 120px;
}

.upload-checking {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #909399;
  padding: 40px 0;
  justify-content: center;
  font-size: 14px;
}

.upload-summary {
  margin-bottom: 16px;
}

.upload-file-group {
  margin-bottom: 14px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.upload-file-group-title {
  background: #f5f7fa;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 6px;
}

.upload-file-list {
  max-height: 200px;
  overflow-y: auto;
}

.upload-file-list--dup {
  background: #fffbf0;
}

.upload-file-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  font-size: 13px;
  border-top: 1px solid #f0f0f0;
}

.upload-file-item--new {
  color: #303133;
}

.upload-file-item--dup {
  color: #909399;
}

.upload-file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-size {
  color: #c0c4cc;
  font-size: 12px;
  white-space: nowrap;
}

.upload-list-more-tip {
  padding: 8px 12px;
  font-size: 12px;
  color: #909399;
  border-top: 1px dashed #ebeef5;
  background: #fafafa;
}

.upload-all-dup {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #E6A23C;
  padding: 30px 0;
  justify-content: center;
  font-size: 14px;
}

/* 上传进度面板 */
.upload-progress-panel {
  padding: 4px 0;
}

.upload-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.upload-progress-list {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  margin-top: 8px;
}

.upload-progress-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 13px;
  border-top: 1px solid #f0f0f0;
}

.upload-progress-item:first-child {
  border-top: none;
}

.upload-progress-status {
  white-space: nowrap;
  font-size: 12px;
}

/* 文件详情弹窗 */
.detail-dialog .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}
.detail-dialog .el-dialog__body {
  padding: 0;
}
.detail-dialog .el-dialog__footer {
  padding: 0;
  border-top: 1px solid #ebeef5;
}

.detail-dialog-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.detail-dialog-title i {
  font-size: 18px;
  color: #409eff;
}

.detail-dialog-body {
  display: flex;
  height: 520px;
}

/* 左侧预览区 */
.detail-preview-area {
  flex: 1;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-width: 0;
}
.detail-preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.25s ease;
  transform-origin: center center;
}
.detail-preview-video {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  background: #000;
}

/* 右侧信息区 */
.detail-info-area {
  width: 300px;
  flex-shrink: 0;
  padding: 20px;
  overflow-y: auto;
  border-left: 1px solid #ebeef5;
}
.detail-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}
.detail-info-grid {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.detail-info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 9px 0;
  border-bottom: 1px solid #f5f7fa;
}
.detail-info-item:last-child {
  border-bottom: none;
}
.detail-info-label {
  font-size: 13px;
  color: #909399;
  flex-shrink: 0;
  line-height: 1.5;
}
.detail-info-value {
  font-size: 13px;
  color: #303133;
  text-align: right;
  word-break: break-all;
  margin-left: 8px;
  line-height: 1.5;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 底部操作栏 */
.detail-dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}
.detail-actions-left,
.detail-actions-right {
  display: flex;
  gap: 4px;
}
.detail-action-btn {
  width: 32px;
  height: 32px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #606266 !important;
  transition: all 0.2s;
}
.detail-action-btn:hover {
  background: #f0f2f5;
  color: #409eff !important;
}
.detail-action-btn i {
  font-size: 16px;
}
.detail-action-btn--danger:hover {
  background: #fef0f0;
  color: #f56c6c !important;
}

/* 移动到文件夹 — 内嵌树形 */
.move-folder-body {
  display: flex;
  flex-direction: column;
  height: 460px;
}
.move-folder-selected-tip {
  padding: 10px 4px 14px;
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
}
.move-folder-selected-tip i {
  color: #409EFF;
  margin-right: 4px;
}
.move-folder-tree-wrap {
  flex: 1;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafbfc;
  padding: 6px 0;
}
.move-folder-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 14px;
  font-size: 13px;
  color: #303133;
  cursor: pointer;
  transition: background 0.15s;
  border-radius: 6px;
  margin: 0 4px;
}
.move-folder-item:hover {
  background: #f0f7ff;
}
.move-folder-item.is-active {
  background: #ecf5ff;
  color: #409EFF;
  font-weight: 600;
}
.move-folder-icon {
  font-size: 15px;
  color: #e6a23c;
  flex-shrink: 0;
}
.move-folder-check {
  margin-left: auto;
  color: #409EFF;
  font-size: 14px;
  font-weight: 700;
}
.move-folder-tree {
  padding: 0 4px;
  background: transparent;
}
.move-folder-tree-node {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  width: 100%;
  padding: 1px 0;
}
.move-folder-tree-node.is-active {
  color: #409EFF;
  font-weight: 600;
}
.move-folder-tree-node .move-folder-icon {
  color: #e6a23c;
}
.move-folder-tree-node.is-active .move-folder-icon {
  color: #409EFF;
}
.move-folder-tree >>> .el-tree-node__content {
  height: 34px;
  border-radius: 6px;
  margin: 1px 0;
}
.move-folder-tree >>> .el-tree-node__content:hover {
  background: #f0f7ff;
}
.move-folder-target-label {
  font-size: 13px;
  color: #909399;
}
.move-folder-target-label strong {
  color: #409EFF;
}


.download-dialog-body {
  max-height: 400px;
  overflow-y: auto;
}
.download-hint {
  margin-bottom: 16px;
}
.download-folder-tree {
  max-height: 200px;
  overflow-y: auto;
}
.download-materials-summary {
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 8px;
  font-size: 13px;
  color: #606266;
}
.download-materials-summary .no-selection {
  color: #909399;
}
.download-materials-summary .more-tag {
  margin-left: 4px;
  color: #909399;
}

</style>

<style>
.folder-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.folder-dialog .el-dialog__header {
  padding: 14px 18px;
  background: #f7f9fc;
  border-bottom: 1px solid #eef2f7;
}

.folder-dialog .el-dialog__title {
  font-weight: 600;
  color: #1f2d3d;
}

.folder-dialog .el-dialog__body {
  padding: 16px 20px 8px;
}

.folder-dialog .el-form-item__label {
  font-weight: 600;
  color: #606266;
  margin-bottom: 6px;
}

.folder-dialog .el-form-item {
  margin-bottom: 16px;
}

.folder-dialog .el-form-item__error {
  margin-top: 6px;
}

.folder-dialog .el-input__inner,
.folder-dialog .el-select .el-input__inner,
.folder-dialog .el-input-number__inner {
  border-radius: 8px;
  background: #f8fafc;
}

.folder-dialog .el-input-number {
  width: 100%;
}

.folder-dialog .el-input-number__increase,
.folder-dialog .el-input-number__decrease {
  border-radius: 6px;
}

.folder-dialog .dialog-footer {
  padding: 12px 20px 18px;
  border-top: 1px solid #f0f2f5;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.move-folder-dialog .dialog-footer {
  padding: 12px 20px 14px;
  border-top: 1px solid #f0f2f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.folder-dialog .el-button {
  border-radius: 8px;
  min-width: 72px;
}

.folder-dialog .dialog-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.folder-dialog .dialog-title i {
  color: #409EFF;
}
</style>
